<template>
  <div class="dev-debug-data-block" :style="blockStyle">
    <div class="dev-debug-data-block__header">
      <span class="dev-debug-data-block__title">{{ title }}</span>
      <CopyOutlined
        class="dev-debug-data-block__copy"
        title="複製"
        @click="onCopy"
      />
    </div>
    <pre class="dev-debug-data-block__content">{{ formattedText }}</pre>
  </div>
</template>

<script>
import { computed } from 'vue'
import CopyOutlined from '@ant-design/icons-vue/lib/icons/CopyOutlined'
import { message as antMessage } from 'ant-design-vue'

const formatDebugData = (data) => {
  try {
    return JSON.stringify(data, null, 2)
  } catch (error) {
    return `[無法序列化] ${error?.message || error}`
  }
}

export default {
  name: 'DevDebugDataBlock',
  components: { CopyOutlined },
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      default: undefined,
    },
    maxHeight: {
      type: String,
      default: '300px',
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  setup(props) {
    const formattedText = computed(() => formatDebugData(props.data))

    const blockStyle = computed(() => ({
      width: props.width,
      maxWidth: props.width,
      flex: props.width !== '100%' ? `0 0 ${props.width}` : undefined,
    }))

    const onCopy = async () => {
      try {
        await navigator.clipboard.writeText(formattedText.value)
        antMessage.success('已複製到剪貼簿')
      } catch (error) {
        antMessage.error('複製失敗')
        console.error('[DevDebugDataBlock] copy failed', error)
      }
    }

    return {
      formattedText,
      blockStyle,
      onCopy,
      contentMaxHeight: computed(() => props.maxHeight),
    }
  },
}
</script>

<style scoped>
.dev-debug-data-block {
  min-width: 0;
  padding-right: 8px;
}

.dev-debug-data-block__header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.dev-debug-data-block__title {
  font-size: 12px;
  font-weight: 600;
  word-break: break-all;
}

.dev-debug-data-block__copy {
  flex-shrink: 0;
  font-size: 12px;
  color: #8c8c8c;
  cursor: pointer;
}

.dev-debug-data-block__copy:hover {
  color: #1677ff;
}

.dev-debug-data-block__content {
  margin: 0;
  padding: 8px;
  font-size: 10px;
  max-height: v-bind(contentMaxHeight);
  overflow: auto;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
